/* eslint-disable no-undefined */
// import classNames from 'classnames';
import PropTypes from 'prop-types';
import styleSheet from './styles/scorePicker.module.scss';

const styles = styleSheet.locals || {};

const MAX_SCORE = 999;

/**
 * Component for the PredictScreen
 *
 * @param {object} props prediction option props
 * @param {object} props.teamName scorePredictor option data
 * @param {number} props.score current score for the team
 * @param {Function} props.onIncrement function to increment the score
 * @param {Function} props.onDecrement function to decrement the score
 * @param {Function} props.onChange change function
 * @param {boolean} [props.useSmallFont] whether to use small font for the score input
 * @returns {Function} <ScorePicker />
 */
function ScorePicker({
    teamName,
    score,
    onIncrement,
    onDecrement,
    onChange,
    useSmallFont = false
}) {
    const handleInputChange = (event) => {
        let rawValue = event.target.value.replace(/[^0-9]/g, '');
        if (rawValue === '') {
            rawValue = '0';
        }
        let clampedValue = Math.max(0, Math.min(Number(rawValue), MAX_SCORE));
        if (onChange) {
            onChange(clampedValue);
        }
    };

    const inputClass = useSmallFont
        ? `${styles.scorePickerInput} ${styles.scorePickerInputSmall}`
        : styles.scorePickerInput;

    return (
        <>
            <style>{styleSheet.toString()}</style>
            <div
                part="score-predictor-score-picker"
                className={styles.scorePicker}
            >
                {/* Minus Button */}
                <button
                    part="score-predictor-score-decrement"
                    className={styles.scorePickerButton}
                    onClick={onDecrement}
                    disabled={score === 0}
                    aria-label={`Decrement ${teamName} score`}
                >
                    -
                </button>

                <input
                    part="score-predictor-score-value"
                    type="number"
                    min={0}
                    max={MAX_SCORE}
                    value={score}
                    onChange={handleInputChange}
                    className={inputClass}
                    aria-label={`Type ${teamName} score`}
                    id="score-typing-input"
                />

                {/* Plus Button */}
                <button
                    part="score-predictor-score-increment"
                    className={styles.scorePickerButton}
                    onClick={onIncrement}
                    disabled={score === MAX_SCORE}
                    aria-label={`Increment ${teamName} score`}
                    data-testid="add-score-button"
                >
                    +
                </button>
            </div>
        </>
    );
}

ScorePicker.propTypes = {
    teamName: PropTypes.string.isRequired,
    score: PropTypes.number,
    onIncrement: PropTypes.func.isRequired,
    onDecrement: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    useSmallFont: PropTypes.bool
};

export default ScorePicker;
